<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Open Linked Planogram</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <p class="mb-3">
    This is a <strong>linked planogram</strong><ng-container *ngIf="planogram.referenceName"> of <strong>{{ planogram.referenceName }}</strong></ng-container>.
    Choose what you'd like to open:
  </p>
  <div class="d-flex flex-column gap-2">
    <button type="button" class="btn btn-primary text-start" [disabled]="!hasLayout" (click)="choose('view-only')">
      <i class="bi bi-eye me-2"></i> Open linked planogram (view only)
      <small class="d-block">This store's planogram. You can export it, but not edit it.</small>
    </button>
    <button type="button" class="btn btn-outline-primary text-start" [disabled]="!hasApproved" (click)="choose('reference-approved')">
      <i class="bi bi-check2-circle me-2"></i> Open reference planogram (approved state)
      <small class="d-block text-muted" *ngIf="!hasApproved">The reference planogram has no approved state.</small>
    </button>
    <button type="button" class="btn btn-outline-primary text-start" [disabled]="!hasLatest" (click)="choose('reference-latest')">
      <i class="bi bi-pencil-square me-2"></i> Open reference planogram (latest state)
    </button>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
